<template>
    <div class="border-l border-r border-gray-200">
        <cost-plan-section v-for="section in sectionData"
                                  :key="section.id"
                                  :section="section"
                                  :contract="contract"
                                  @editBuildup="(i) => $emit('editBuildup',i)"
                                  :currently-building="currentlyBuilding"
                                  :current-viewing="currentViewing"
                                  :readonly="true"
                                  :show-item-progress="showItemProgress"
                                  :show-omitted="true"
        ></cost-plan-section>
    </div>
</template>

<script>
import {cloneDeep} from "lodash";
import CostPlanSection from "./CostPlanSection.vue";
import * as math from "mathjs";
import {resolveNumericText} from "@utils";

export default {
    components: {
        CostPlanSection
    },
    props: {
        contract: Object,
        operations: Array,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        currentlyBuilding: false,
        currentViewing: false,
    },
    data() {
        return {}
    },
    computed: {
        sectionData() {
            let sections = [];
            let findSectionInContract = (sectionId) => {
                return this.contract.sections.find((x) => x.id === sectionId);
            }
            let findTaskInContract = (sectionId, taskId) => {
                let s = findSectionInContract(sectionId)
                return s ? s.tasks.find((x) => x.id === taskId) : false
            }

            let findItemInContract = (sectionId, taskId, itemId) => {
                let t = findTaskInContract(sectionId, taskId)
                return t ? t.items.find((x) => x.id === itemId) : false
            }

            let addSection = (sectionId) => {
                if (!sections.find((x) => x.id === sectionId)) {
                    let section = findSectionInContract(sectionId)
                    section = section ? cloneDeep(section) : {id: sectionId}
                    section.tasks = [];
                    sections.push(section);
                }
                return sections.find((x) => x.id === sectionId);
            }

            let addTask = (sectionId, taskId) => {
                let s = addSection(sectionId)
                if (!s.tasks.find((x) => x.id === taskId)) {
                    let task = findTaskInContract(sectionId, taskId)
                    task = task ? cloneDeep(task) : {id: taskId}
                    task.items = [];
                    s.tasks.push(task);
                }
                return s.tasks.find((x) => x.id === taskId);
            }

            let addItem = (sectionId, taskId, itemId) => {
                let t = addTask(sectionId, taskId)
                if (!t.items.find((x) => x.id === itemId)) {
                    let item = findItemInContract(sectionId, taskId, itemId)
                    t.items.push(item ? cloneDeep(item) : {id: itemId});
                }
                return t.items.find((x) => x.id === itemId);
            }

            this.operations.filter((i) => i.subject.type === 'Section').forEach((op) => {
                let s = addSection(op.subject.id)
                if (op.type === 'Omission') {
                    s.proposedStatus = 'OMITTED'
                } else if (op.type === 'Addition') {
                    Object.assign(s, op.value)
                    s.proposedStatus = 'ADDED'
                } else {
                    Object.assign(s, op.value)
                    s.proposedStatus = 'SUBSTITUTED'
                }
            })
            this.operations.filter((i) => i.subject.type === 'Task').forEach((op) => {
                let t = addTask(op.value.sectionId, op.subject.id)

                if (op.type === 'Omission') {
                    t.proposedStatus = 'OMITTED'
                } else if (op.type === 'Addition') {
                    t.proposedStatus = 'ADDED'
                } else {
                    Object.assign(t, op.value)
                    t.proposedStatus = 'SUBSTITUTED'
                }
            })
            this.operations.filter((i) => i.subject.type === 'Item').forEach((op) => {
                let i = addItem(op.value.sectionId, op.value.taskId, op.subject.id)

                if (op.type === 'Omission') {
                    i.proposedStatus = 'OMITTED'
                } else if (op.type === 'Addition') {
                    Object.assign(i, op.value)
                    i.proposedStatus = 'ADDED'
                } else if (op.type === 'BuildupChange') {
                    if (op.value.buildup) {
                        i.buildup = op.value.buildup
                    }
                    if (op.value.materials) {
                        i.materials = op.value.materials
                        i.materials.forEach((s) => {
                            let component = i.buildup.find(c => c.id === s.componentId)
                            if (component) {
                                s.component = component
                            }
                        })
                    }
                    if (op.value.labours) {
                        i.labours = op.value.labours
                        i.labours.forEach((s) => {
                            let component = i.buildup.find(c => c.id === s.componentId)
                            if (component) {
                                s.component = component
                            }
                        })
                    }
                    if (op.value.fixedCosts) {
                        i.fixedCosts = op.value.fixedCosts
                        i.fixedCosts.forEach((s) => {
                            let component = i.buildup.find(c => c.id === s.componentId)
                            if (component) {
                                s.component = component
                            }
                        })
                    }
                    i.proposedStatus = 'SUBSTITUTED'
                } else {
                    Object.assign(i, op.value)
                    i.proposedStatus = 'SUBSTITUTED'
                }
            })
            return sections;
        }
    },
    methods: {},
}
</script>
